// Money is stored as a count of deniers. Display it in the period livre/sou/denier
// system: 12 deniers = 1 sou, 20 sous = 1 livre (= 240 deniers).
export const DENIERS_PER_SOU = 12;
export const DENIERS_PER_LIVRE = 240;

export function formatMoney(deniers: number): string {
  const total = Math.max(0, Math.floor(deniers));
  const livre = Math.floor(total / DENIERS_PER_LIVRE);
  const sou = Math.floor((total % DENIERS_PER_LIVRE) / DENIERS_PER_SOU);
  const den = total % DENIERS_PER_SOU;

  const parts: string[] = [];
  if (livre) parts.push(`${livre}l`);
  if (sou) parts.push(`${sou}s`);
  if (den || parts.length === 0) parts.push(`${den}d`);
  return parts.join(' ');
}
